import type { PortalContextKey } from './portalContext'

let selectedContext: PortalContextKey | { kind: 'application'; id: string } | undefined

export function setSelectedPortalContext(context: typeof selectedContext) {
  selectedContext = context
}

export function getSelectedOrganizationId() {
  return selectedContext?.kind === 'organization' ? selectedContext.id : null
}
